import SFetch from '@app/utils/sfetch'

onDomLoad(($dom) => {
  $dom.find('#set-company-template-form').each((index, el) => {
    updateMarketUsageBanner(el)
  })
  $dom.find('[data-behavior="company-template-selected"]').each((index, el) => {
    el.addEventListener('change', () => {
      updateMarketUsageBanner(el)
    })
  })
})

function updateMarketUsageBanner(element) {
  const select = document.getElementById('company_company_template_id')
  if (select) {
    const selectedName = select.options[select.selectedIndex].textContent
    const url =
      element.dataset.url +
      '?company_template_name=' +
      encodeURIComponent(selectedName)
    const banner = document.getElementById(
      'company-template-market-usage-banner'
    )

    SFetch.json(url, { method: 'GET' }).then((response) => {
      if (response.length > 0) {
        document.getElementById('client-template-name').textContent =
          selectedName

        banner.style.display = ''
      } else {
        banner.style.display = 'none'
      }
    })
  }
}
